import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { devLog } from "utils/logger";

import IdentityVerification from "./IdentityVerification";

function MemberNumberSignUpAndSignIn(props) {
    const location = useLocation();
    const state = location.state || {};
    
    // 디버깅: 초기 props 및 state 로깅
    devLog("[MemberNumberSignUpAndSignIn] props:", props);
    devLog("[MemberNumberSignUpAndSignIn] location:", location);
    devLog("[MemberNumberSignUpAndSignIn] state:", state);
    
    // 디버깅: 마운트 시 state 객체 구조 확인
    useEffect(() => {
        devLog("[MemberNumberSignUpAndSignIn] 컴포넌트 마운트 - state 세부 정보:", {
            type: state.type,
            storeCode: state.storeCode,
            deviceCode: state.deviceCode,
            paymentData: state.paymentData,
            mobileNumber: state.mobileNumber,
            // 전체 state 객체도 확인
            fullState: state
        });
        
        // 경로 및 referrer 확인
        devLog("[MemberNumberSignUpAndSignIn] 경로 정보:", {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
            key: location.key,
            referrer: document.referrer
        });
    }, []);
    
    // 디버깅: IdentityVerification에 전달되는 props 로깅
    const verificationProps = {
        authType: state.type,
        verificationData: state
    };
    devLog("[MemberNumberSignUpAndSignIn] IdentityVerification에 전달되는 props:", verificationProps);

    return (
        <IdentityVerification 
            authType={state.type}
            verificationData={state}
        />
    );
}

export default MemberNumberSignUpAndSignIn;